/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Security_Sign_In_TitleInputs */

const en_notifications_security_sign_in_title = /** @type {(inputs: Notifications_Security_Sign_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New sign-in detected`)
};

const pt_br2_notifications_security_sign_in_title = /** @type {(inputs: Notifications_Security_Sign_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo acesso detectado`)
};

/**
* | output |
* | --- |
* | "New sign-in detected" |
*
* @param {Notifications_Security_Sign_In_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_security_sign_in_title = /** @type {((inputs?: Notifications_Security_Sign_In_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Security_Sign_In_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_security_sign_in_title(inputs)
	return pt_br2_notifications_security_sign_in_title(inputs)
});